import { Link } from "@tanstack/react-router";

/**
 * Palworld TCG Market Tools & Data Hub utility bar.
 *
 * Rendered beneath the interactive container on the arcade/mini-game routes so
 * link equity flows from the high-traffic game pages into the commercial
 * money pages. `content-visibility: auto` keeps it off the critical render
 * path, and `contain-intrinsic-size` reserves height so it cannot shift layout.
 */
export function MarketToolsBar({ className }: { className?: string }) {
  return (
    <section
      className={`seo-utility-bar glass rounded-2xl border border-border/60 p-5 sm:p-6 ${className ?? ""}`}
      style={{ contentVisibility: "auto", containIntrinsicSize: "0 150px" }}
      aria-labelledby="market-tools-bar"
    >
      <h2 id="market-tools-bar" className="text-xl font-bold">
        Palworld TCG Market Tools &amp; Data Hub
      </h2>
      <p className="mt-2 text-sm text-muted-foreground">
        Finished playing? Move over to the commercial tools to value your deck and pull live tracking analytics:
      </p>
      <ul className="mt-4 flex flex-wrap gap-x-6 gap-y-2 text-sm">
        <li>
          <Link to="/pack-calculator" className="font-semibold text-primary hover:underline">
            Palworld TCG pack calculator tool
          </Link>
        </li>
        <li>
          <Link to="/tcg-sold-prices" className="font-semibold text-primary hover:underline">
            Palworld TCG last sold prices index
          </Link>
        </li>
        <li>
          <Link to="/breeding" className="font-semibold text-primary hover:underline">
            Palworld breeding calculator and data
          </Link>
        </li>
      </ul>
    </section>
  );
}
